import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

type InfoBannerColorClassType = 'branded' | 'red' | 'blue' | 'orange';

@Component({
    selector: 'fi-info-banner',
    template: `
        <div class="fi-info-banner-container" [class.outlined]="isBannerOutlined" [ngClass]="bannerColorClass">
            <mat-icon class="fi-info-banner-icon" [ngClass]="matIconClass" />
            <span class="fi-info-banner-text" [innerHTML]="bannerText"></span>
            @if (buttonText) {
                <button mat-button class="fi-info-banner-button" (click)="onButtonClick()">{{ buttonText }}</button>
            }
        </div>
    `,
    styleUrl: './fi-info-banner.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-info-banner' },
    standalone: false,
})
export class FiInfoBannerComponent {
    @Input({ required: true }) matIconClass: string;
    @Input({ required: true }) bannerText: string;
    @Input() bannerColorClass: InfoBannerColorClassType = 'branded';
    @Input() isBannerOutlined: boolean = false;
    @Input() buttonText: string | undefined;
    @Output() buttonClick = new EventEmitter<void>();

    protected onButtonClick(): void {
        this.buttonClick.emit();
    }
}
